module.exports = __webpack_public_path__ + "img/saishianpai-icon-4.b4c2cb5e.png";